<template>
   <detail-layout v-if="true">
    <template slot="header">
      <base-header icon="user" :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <el-form-item v-if="!!form.guid" prop="guid">
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('configAAD.details.guid') }}</label>
            <el-input class="w-full" v-model="form.guid" :disabled="true" clearable />
          </el-form-item>
          <el-form-item prop="ClientID">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('configAAD.details.clientid') }}</label>
            <el-input class="w-full" v-model="form.ClientID" :disabled="isRoleUserOrConsulta" clearable />
          </el-form-item>
          <el-form-item prop="TenantID">
            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('configAAD.details.tenantid') }}</label>
            <el-input class="w-full" v-model="form.TenantID" :disabled="isRoleUserOrConsulta" clearable />
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack"
                :loading="isGeneralLoading" />
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
                :loading="isGeneralLoading" :disabled="isRoleUserOrConsulta" />
        </template>
      </base-footer>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getAadConfig } from '@/services/configurations/aad/getAadConfig'
import { updateAadConfig } from '@/services/configurations/aad/updateAadConfig'
import { getClient } from '@/services/clients/getClient'
import { i18n } from '@/i18n'

export default {
  components: {
    DetailLayout
  },
  data () {
    return {
      header: {
        title: i18n.t('configAAD.header'),
        icon: 'config',
        url: 'configurations/clients/details',
        breadcrumb: [],
        nav: [],
        params: this.$route.params
      },
      rules: {
        ClientID: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ], 
        TenantID: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ], 
      },
      form: {
        guid: '',
        ClientID: '',
        TenantID: ''
      },
    }
  },

  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    id: function () {
      return this.$route.params.id ? this.$route.params.id : this.$store.getters['auth/user'].idCliente
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
  },

  methods: {
    goBack: function () {
      this.$router.push({ name: 'configurations/clients/details', params: this.$route.params.id })
    },
    setDataForm: function (aadConfig) {
      this.form.guid = aadConfig?.Guid ?? ''
      this.form.ClientID = aadConfig?.ClientID ?? ''
      this.form.TenantID = aadConfig?.TenantID ?? ''
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            const data = {
              idCliente: this.id,
              ClientID: this.form.ClientID,
              TenantID: this.form.TenantID
            }
            var response = await updateAadConfig(data)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [' + response.codError + ']')
            } else {
              this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCliente: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
  },

  created: async function () {
    this.$store.commit('setIsLoading', true)
    var params = { idCliente: this.id }
    var response = await getAadConfig(params)
    this.setDataForm(response?.respuesta)
    this.$store.commit('setIsLoading', false)
    const breadcrumbs = []
    breadcrumbs.push({
      path: this.role === 3 ? 'configurationssa' : 'configurations',
      name: i18n.t('configurations.header')
    })
    breadcrumbs.push({
      path: 'configurations/clients',
      name: i18n.t('clients.header')
    })
    if (this.id !== -1) {
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.Cliente.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.Cliente.Nombre)
      }
    }
    this.header.breadcrumb = breadcrumbs
  }
}

  
</script>

<style>

</style>
